import { Injectable } from '@angular/core';

/**
 * Session-scoped state for the "What's New" dialog.
 *
 * DefaultHeaderComponent cannot hold this. '' and 'access-denied' are separate
 * top-level routes that render the same layout, and the app registers no
 * RouteReuseStrategy, so navigating between them destroys the header and mounts a
 * new one — including on the "Go To Dashboard" click that takes the user off the
 * Access Denied page. Anything the component remembers is therefore reset on exactly
 * the navigation a dismissal has to survive.
 *
 * This service is providedIn: 'root', so it outlives those remounts and resets only
 * on a full page load, which matches "dismissed for this session".
 */
@Injectable({
  providedIn: 'root'
})
export class AnnouncementDialogStateService {
  private dismissed = false;

  get isDismissed(): boolean {
    return this.dismissed;
  }

  markDismissed(): void {
    this.dismissed = true;
  }
}
